import { Component, OnInit,AfterViewInit, Input,Output,EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormControl,UntypedFormArray } from '@angular/forms';
import { NgbNav, NgbNavItem, NgbNavContent } from '@ng-bootstrap/ng-bootstrap';
import { WantedcreditService } from '../services/wantedcredit.service';
import { LookupService } from '../services/lookup.service';
import { SearchCriteria} from '../core/models/search-criteria'
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  @Input('category') category
  set setCategory(value: string) {
    this.category = value;
  }
  wantedCredits: any = [];
  subregions: any = [];
  fgSearch: UntypedFormGroup;
  fgResults: UntypedFormGroup;
  tradingGroups: any = [];
  filteredTgGroups: any = [];
  p: number = 1;
  totalRecords: number = 0;
  headerJson = [
    {
      field: 'creditId',
      displayName: 'Credit ID'
    },
    
    {
      field: 'creditCategory',
      displayName: 'Credit Category'
    },
    {
      field: 'offsetTradingGroup',
      displayName: 'Offset Trading Group'
    },
    {
      field: 'numberOfCredits',
      displayName: 'Number of Credits wanted'
    },
    {
      field: 'hbt',
      displayName: 'Hollow-Bearing Trees Presence'
    },
    
  ];

  headerJsonSpecies = [
    {
      field: 'creditId',
      displayName: 'Credit ID'
    },

    {
      field: 'creditCategory',
      displayName: 'Credit Category'
    },
    {
      field: 'name',
      displayName: 'Offset Trading Group'
    },
    {
      field: 'numberOfCredits',
      displayName: 'Number of Credits Wanted'
    },
   
  ];
  constructor(private wantedCreditsService: WantedcreditService,
    private lookupService: LookupService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit() {
    this.generateFormGroup();
    this.generateResultsFormGroup();
    this.loadIbraSubregions();
    this.loadPreviousSearchResults();
  }

  get creditIdLabel(): string {
    return this.category == "ecosystem" ? "PCT" : "Species";
  }

  get allowDownload(): boolean {
   //Allow download excel only when atleast one filter is selected
    var searchCriteria: SearchCriteria = this.fgSearch.value;
    return searchCriteria.subregion != '' || searchCriteria.offsetTradingGroup != ''
    ||searchCriteria.creditId>0 || searchCriteria.creditName!=''

  }
  get enableSearch(): boolean {
    var searchCriteria: SearchCriteria = this.fgSearch.value;
    return this.category != "species" ? searchCriteria.subregion != '' : true;
  }
  generateFormGroup() {
    this.fgSearch = this.fb.group({
      category: [''],
      subregion: [''],
      creditId: [''],
      creditName: [''],
      offsetTradingGroup: [''],
      hbt:['']

    });
  }

  generateResultsFormGroup() {
    this.fgResults = this.fb.group({
      resultsArray: new UntypedFormArray([])
    });
  }

  loadPreviousSearchResults() {
    if (this.category == "ecosystem" && this.wantedCreditsService.ecoResults != null) {
      this.wantedCredits = this.wantedCreditsService.ecoResults;
    }
    else if (this.category == "species" && this.wantedCreditsService.speciesResults != null) {
      this.wantedCredits = this.wantedCreditsService.speciesResults;
    }
    const criteria = this.category == "ecosystem" ? this.wantedCreditsService.searchCriteria:this.wantedCreditsService.specieSearchCriteria; 
    if (criteria!= null) {
      if (this.category == "ecosystem") {
        this.fgSearch.patchValue({
          subregion: criteria.subregion,
          creditId: criteria.creditId > 0 ? criteria.creditId:"",
          offsetTradingGroup: criteria.offsetTradingGroup,
          hbt: criteria.hbt
        });
      }
      else {
        this.fgSearch.patchValue({
          creditName: criteria.creditName
          
        });
      }

    }
    this.buildCheckboxList();
  }

  get resultsCheckboxList(): UntypedFormArray {
    return this.fgResults.get('resultsArray') as UntypedFormArray;
  }

  public getSelectedCredits(): any {

    var selectedCredits = this.resultsCheckboxList.controls.map((checked, index) => {
      
      var effectiveIndex = ((this.p - 1) * 25) + index;
      return checked.value == true ? this.wantedCredits[effectiveIndex] : null
    }).filter(v => v != null);
    
    return selectedCredits;
  }

  loadIbraSubregions() {
    this.lookupService.ibraSubregions.subscribe(result => {
      this.subregions = result;
    });
  }

  search() {
    var searchCriteria: SearchCriteria = this.fgSearch.value;
    searchCriteria.pageNumber = this.p;
    searchCriteria.category = this.category == "ecosystem" ? "ecosystem" : "species";
    if (this.fgSearch.value.hbt == "") searchCriteria.hbt = null;
    if (this.fgSearch.value.creditId == "") searchCriteria.creditId = 0;
    if (this.category != null &&
      this.category != undefined &&
      this.category.toLowerCase() == 'speciesv') searchCriteria.ruleNumber = 2;

    this.wantedCreditsService.search(searchCriteria).subscribe(result => {
      if (result == null || result == undefined) return;
      this.totalRecords = result.totalRecords;
      const results = result.results;
      this.wantedCredits = results;
      this.buildCheckboxList();
      if (this.category == "ecosystem") {
        this.wantedCreditsService.ecoResults = results
        //persist search criteria as
        this.wantedCreditsService.searchCriteria = searchCriteria;
      }
      else {
        this.wantedCreditsService.speciesResults = results;
        this.wantedCreditsService.specieSearchCriteria = searchCriteria;
      } 
     

    });

  }

  buildCheckboxList() {
    if (this.wantedCredits == null || this.wantedCredits == undefined) return;
    let alreadyAdded:boolean = false;
    this.wantedCredits.map((item, index) => {
      alreadyAdded = false;
      if (this.wantedCreditsService.selectedCredits != null
        && this.wantedCreditsService.selectedCredits.findIndex(c => c.id == item.id) >= 0) {
         alreadyAdded = true;
      }         

      this.resultsCheckboxList.push(this.fb.control(alreadyAdded));
    });
  }

  getPage($event) {
    this.p = $event;
    this.search();
  }

  checkSelectedCredits(event,id:number) {
    //console.log(event);
    for (let i = 0; i < event.target.form.length; i++) {
      if (event.target.form[i].checked) {
        return true;
      }
      else {
        return false;
      }
      
    }
  }

  filterTradingGroups(event) {
    
    if (event.target.value.length <=0) this.filteredTgGroups = this.tradingGroups;
    else {
      this.wantedCreditsService.getTradingGroupsBySubregion(event.target.value).subscribe((result: any) => {
        this.filteredTgGroups = result;
      });
         
    }
    
  }
  absoluteIndex(indexOnPage: number): number {
    return 0;
    // return this.itemsPerPage * (this.currentPage - 1) + indexOnPage;
  }
}
